const borders = {
  sizes: {
    sm: '1px',
    md: '2px',
    md2: '3px',
    lg: '4px',
    xl: '8px'
  },
  radius: {
    sm: '0.125rem',
    md: '0.25rem',
    lg: '0.625rem',
    xl: '1rem',
    pill: '15rem',
    circle: '50%'
  }
}

export default Object.freeze(borders)
